/* eslint-disable @typescript-eslint/no-explicit-any */
export const removeDuplicate = (arr: any) => {
  const set = new Set();
  return arr.reduce((finalList: any, acc: any) => {
    const { id } = acc;
    const key = `${id}`;
    if (!set.has(key)) {
      finalList.push({
        ...acc
      });
    }
    set.add(key);
    return finalList;
  }, []);
};
